<template>
  <div class="ecology">
    <EcologyBanner/>
    <EcologyDomain/>
    <EcologyService/>
    <EcologyAchievement/>
  </div>
</template>

<script>
import EcologyBanner from '@/page/ecology/components/ecologyBanner.vue'
import EcologyDomain from '@/page/ecology/components/ecologyDomain.vue'
import EcologyService from '@/page/ecology/components/ecologyService.vue'
import EcologyAchievement from '@/page/ecology/components/ecologyAchievement.vue'

export default {
  name: "index",
  components: {EcologyAchievement, EcologyService, EcologyDomain, EcologyBanner}
}
</script>


<style scoped lang="scss">
.ecology{

}
</style>
